import { render, staticRenderFns } from "./HealthPathsGymConversionStatistics.vue?vue&type=template&id=2ad7218e"
import script from "./HealthPathsGymConversionStatistics.vue?vue&type=script&lang=ts"
export * from "./HealthPathsGymConversionStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports